/**
 * Утилита для сжатия изображений перед загрузкой на сервер.
 * 
 * compressImage — принимает File, возвращает Promise<File>.
 * Уменьшает до 1200px по большей стороне, конвертирует в JPEG качество 0.8.
 * Применяется: Diagnostic (загрузка фото пробега и пунктов чеклиста)
 */

export const compressImage = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
            const img = new Image()
            img.onload = () => {
                const canvas = document.createElement('canvas')
                const maxSize = 1200
                let width = img.width
                let height = img.height
                if (width > height && width > maxSize) {
                    height = (height * maxSize) / width
                    width = maxSize
                } else if (height > maxSize) {
                    width = (width * maxSize) / height
                    height = maxSize
                }
                canvas.width = width
                canvas.height = height
                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)
                canvas.toBlob((blob) => {
                    if (!blob) {
                        reject(new Error('Не удалось обработать изображение'))
                        return
                    }
                    resolve(new File([blob], 'photo.jpg', { type: 'image/jpeg' }))
                }, 'image/jpeg', 0.8)
            }
            img.onerror = () => reject(new Error('Файл не удалось открыть как изображение'))
            img.src = e.target.result
        }
        reader.onerror = () => reject(new Error('Файл не удалось прочитать'))
        reader.readAsDataURL(file)
    })
}
